<template>
  <div class="container">
    <div class="row mb-4">
      <div class="col-md-6">
        <span class="text-black">
          <i class="fas fa-equals mr-2"></i>Saldo em Dinheiro:
        </span>
      </div>
      <div class="col-md-6 text-right">
        <div class="mr-2">
          {{ closingBalance | decimal }}
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <number-input
          v-model="drawerValue"
          :alias="'Informe o valor que esta na sua gaveta'"
        />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-6">
        <span class="text-black">
          <i class="fas fa-not-equal mr-2"></i>Diferença de caixa:
        </span>
      </div>
      <div class="col-md-6 text-right">
        <div class="mr-2">
          <p class="mb-0 text-success" v-if="difference < 0">
            {{ (difference * -1) | decimal }}
          </p>
          <p class="mb-0 text-success" v-if="difference == 0">
            {{ difference | decimal }}
          </p>
          <p class="mb-0 text-danger" v-if="difference > 0">
            {{ (difference * -1) | decimal }}
          </p>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <span class="text-info">
          O valor acima representa a diferença do caixa após contar o dinheiro
          clique no botão próximo para continuar
        </span>
      </div>
    </div>

    <!-- <div class="row mb-4">
      <div class="col-md-12">
        <blockquote class="blockquote text-center">
          <footer class="blockquote-footer">
            O valor acima representa a diferença do caixa após contar o dinheiro
            clique no botão próximo para continuar
          </footer>
        </blockquote>
      </div>
    </div> -->
    <div class="row mb-4" v-if="difference != 0">
      <div class="col-md-12">
        <button role="button" class="btn btn-danger btn-block" @click="handleStoreAccountTransactionDifference()">
          <i class="fas fa-not-equal"></i> Lançar diferença
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import Form from "../../../mixins/Form.js";
import moment from "moment";

export default {
  props : {
    accountId : {}
  },

  data: () => ({
    drawerValue : 0,

    form: new Form({
      description: {
        value: "Lançamento de diferença do caixa",
      },

      account_plan_id: {
        value: null,
      },

      paid_at: {
        value: null,
        default: moment().format("YYYY-MM-DD"),
      },

      type: {
        options: {
          i: "Entrada",
          o: "Saida",
        },
      },

      value: {
        value: 0,
      },

      
    }),
  }),

  // watch: {
  //   // form.value.value(val) {
  //   //   this.$emit("input", this.difference);
  //   // },
  //   form: {
  //     deep: true,

  //     handler() {
  //       this.form.value > 0
  //         ? (this.form.type.value = "o")
  //         : (this.form.type.value = "i");
  //     },
  //   },
  // },

  computed: {
    closingBalance() {
      return this.$store.getters["drawer/closingBalance"];
    },

    difference() {
      return (this.drawerValue != 0) ? parseFloat(this.closingBalance) - parseFloat(this.drawerValue) : 0;
    },
  },

  methods: {
    async handleStoreAccountTransactionDifference() {
      console.log(this.getValues())
      this.$store.commit("showLoading");
      await this.$store.dispatch(
        "drawer/postEndShiftDifferenceTransaction",
        this.getValues()
      );
      this.$emit('stored')
      
    },

    getValues() {
      let params = {}
      
      params.account_id = this.accountId
      params.value = this.difference
      params.type = (this.difference > 0) ? 'o' : 'i'

      return {...this.form.getValues(), ...params}
    }
  },
};
</script>

<style>
</style>